import { useState } from 'react';
import { Bot, CircleDot, Hand, Info, MousePointer2, Orbit, Rocket, Wrench } from 'lucide-react';
import { Modal } from '../../../Modal';
import { IconButton, Typography } from '../../ui';
import { useTranslation } from '../../../../lib/i18n';
import { useGenericBi } from '../../../../lib/use-generic-bi';
import styles from './WorldHelp.module.css';

const LEGEND = [
  ['intro', Bot],
  ['circles', CircleDot],
  ['maestro', Orbit],
  ['activity', Wrench],
  ['workstations', Wrench],
  ['statuses', Bot],
  ['goals', CircleDot],
  ['waiting', Hand],
  ['rockets', Rocket],
  ['interact', MousePointer2],
  ['modes', Info],
] as const;

export function WorldHelp() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  const { logPageClickBi } = useGenericBi();
  return <>
    <IconButton
      className={styles.trigger}
      size="small"
      variant="contained"
      aria-label={t('home.world.help.title')}
      aria-haspopup="dialog"
      onClick={() => {
        setOpen(true);
        logPageClickBi({ page_name: 'map_home', button_name: 'home-world-help' });
      }}
    ><Info size={16} aria-hidden /></IconButton>
    <Modal open={open} onClose={() => setOpen(false)} title={t('home.world.help.title')}
      labelledBy="world-help-title" size="minimum" maxHeightPx={650} scrollBody headerSeparator>
      <div className={styles.legend}>
        <div className={styles.item}><MousePointer2 size={20} aria-hidden className={styles.icon} /><Typography variant="p2">{t('home.world.walkHint')}</Typography></div>
        <div className={styles.item}><CircleDot size={20} aria-hidden className={styles.icon} /><Typography variant="p2">{t('home.world.missionsHint')}</Typography></div>
        {LEGEND.map(([key, Icon]) => <div key={key} className={styles.item}>
          <Icon size={20} aria-hidden className={styles.icon} />
          <Typography variant="p2">{t(`home.world.help.${key}`)}</Typography>
        </div>)}
      </div>
    </Modal>
  </>;
}
